import {RootState} from "../store";
import {createSelector} from "@reduxjs/toolkit";
import {getMonth, getYear} from "date-fns";
import {Payroll, PayrollStatus} from "../interfaces";
import {isCompletePayroll, isValidString, paginateArray} from "../../utils";

export const selectAllPayrolls = (state: RootState) => state.payrolls.payrolls
export const allPayrollsFetchState = (state: RootState) => state.payrolls.status
export const allPayrollsFetchError = (state: RootState) => state.payrolls.error

export const updatePayrollState = (state: RootState) => state.payrolls.updateStatus
export const updatePayrollError = (state: RootState) => state.payrolls.updateError

export const selectCurrentMonthPayrollByEmployee = (employeeId: string) =>
    createSelector([selectAllPayrolls], payrolls => {
        const currentMonth = getMonth(new Date());
        const currentYear = getYear(new Date());

        return payrolls.find((payroll: Payroll) => {
            const payrollDate = new Date(payroll.created);
            return (
                getMonth(payrollDate) === currentMonth &&
                getYear(payrollDate) === currentYear &&
                payroll.eor_employee?._id === employeeId
            );
        });
    });

export const selectedPayrollsPaginated = (
    currentPage: number,
    limit: number,
    statuses: PayrollStatus[],
    employeeId: string | null = null,
    date: Date | null
) => createSelector([selectAllPayrolls], payrolls => {
    let complete = payrolls.filter(isCompletePayroll)
    if (complete.length !== payrolls.length) {
        const dropped = payrolls.filter((p) => !isCompletePayroll(p)).map((p) => p._id)
        console.warn('Dropping payrolls with unresolved relations:', dropped)
    }

    if(isValidString(employeeId)){
        complete = complete.filter((p) => p.eor_employee._id === employeeId)
    }
    if (statuses.length) {
        complete = complete.filter((p) => statuses.includes(p.status))
    }
    if (date){
        const selectedMonth = getMonth(date);
        const selectedYear = getYear(date);
        complete = complete.filter((p) => {
            const payrollDate = new Date(p.created);
            return (
                selectedMonth === getMonth(payrollDate) &&
                selectedYear === getYear(payrollDate)
            )
        })
    }
    complete = complete.sort((a,b) => new Date(b.created).getTime() - new Date(a.created).getTime())
    return paginateArray(complete, currentPage, limit)
})

export const selectPayrollById = (id: string) => createSelector(
    [selectAllPayrolls],
    payrolls => payrolls.find(p => p._id === id)
);
